import { TranslationKeys } from './TranslationKeys'

export const LocalhostUrl = 'https://localhost:44304'
export const DemoDev = 'jD1ZinEA5YvpWGi9GgvTAQ%3D%3D'

//Environment
export enum Env {
  Prod = 'prod',
  Demo = 'demo',
  Develop = 'development',
}

export const AllFreeWidthColumn = 'all'
export const UnretrievedTranslation = 'KIO00000'
export const OverwriteConfigurationKey = 'Atelier_Overwrite_Configuration'

/*Datetime format*/
export const DateFormat = 'DD/MM/YYYY'
export const DateFormatNoYear = 'DD/MM'
export const TimeFormat = 'HH:mm'
export const DefaultFromDate = '01/01/1998'

/*Images missing and not gound*/
export const imgMissingIt = '/images/missing it.png'
export const imgMissingEn = '/images/missing en.png'
export const imgNotFoundIt = '/images/notfound it.png'
export const imgNotFoundEn = '/images/notfound en.png'
export const missingImageGen = '/images/missing-gen.png'
export const notFoundImageGen = '/images/notfound-gen.png'

/*Grid Layout*/
export const quantitySectionId = 'quantities-section'
export const quantitySectionContainer = 'quantity-container'
export const movementSectionId = 'movements-section'
export const movementSectionContainer = 'movement-container'
export const marketplaceSectionId = 'marketplace-section'
export const marketplaceSectionContainer = 'marketplace-container'
export const priceGenerationSectionId = 'price-generation-section'
export const priceGenerationContainer = 'price-container'
export const quantityLimitSectionId = 'quantity-limit-section'
export const quantityLimitContainer = 'quantity-limit-container'
export const imagesSectionId = 'images-section'
export const imagesContainer = 'images-container'
export const descriptionsSectionId = 'descriptions-section'
export const descriptionsContainer = 'descriptions-container'
export const pubblcationsSectionId = 'pubblcations-section'
export const pubblcationsContainer = 'pubblcations-container'
export const barcodesSectionId = 'barcodes-section'
export const barcodesContainer = 'barcodes-container'
export const defaultGridRowHeight = 1

export const gridLayoutContainerIdRelation = [
  { id: quantitySectionId, container: quantitySectionContainer },
  { id: movementSectionId, container: movementSectionContainer },
  { id: marketplaceSectionId, container: marketplaceSectionContainer },
  { id: priceGenerationSectionId, container: priceGenerationContainer },
  { id: quantityLimitSectionId, container: quantityLimitContainer },
  { id: imagesSectionId, container: imagesContainer },
  { id: descriptionsSectionId, container: descriptionsContainer },
  { id: pubblcationsSectionId, container: pubblcationsContainer },
  { id: barcodesSectionId, container: barcodesContainer },
]

const quantityLayout = {
  i: quantitySectionId,
  x: 0,
  y: 0,
  w: 12,
  h: 1,
  isDraggable: true,
  isBounded: true,
  resizeHandles: ['se'],
}

const movementsLayout = {
  i: movementSectionId,
  x: 0,
  y: 1,
  w: 12,
  h: 1,
  isDraggable: true,
  isBounded: true,
  resizeHandles: ['se'],
}

const marketplaceLayout = {
  i: marketplaceSectionId,
  x: 0,
  y: 2,
  w: 12,
  h: 1,
  isDraggable: true,
  isBounded: true,
  resizeHandles: ['se'],
}

const priceLayout = {
  i: priceGenerationSectionId,
  x: 0,
  y: 3,
  w: 12,
  h: 1,
  isDraggable: true,
  isBounded: true,
  resizeHandles: ['se'],
}

const quantityLimitLayout = {
  i: quantityLimitSectionId,
  x: 0,
  y: 4,
  w: 12,
  h: 1,
  isDraggable: true,
  isBounded: true,
  resizeHandles: ['se'],
}

const imagesLayout = {
  i: imagesSectionId,
  x: 0,
  y: 5,
  w: 12,
  h: 1,
  isDraggable: true,
  isBounded: true,
  resizeHandles: ['se'],
}

const descsLayout = {
  i: descriptionsSectionId,
  x: 0,
  y: 6,
  w: 12,
  h: 1,
  isDraggable: true,
  isBounded: true,
  resizeHandles: ['se'],
}

const pubsLayout = {
  i: pubblcationsSectionId,
  x: 0,
  y: 7,
  w: 12,
  h: 1,
  isDraggable: true,
  isBounded: true,
  resizeHandles: ['se'],
}

const barcodesLayout = {
  i: barcodesSectionId,
  x: 0,
  y: 8,
  w: 12,
  h: 1,
  isDraggable: true,
  isBounded: true,
  resizeHandles: ['se'],
}

export const reactGridLayoutArray = [
  quantityLayout,
  movementsLayout,
  marketplaceLayout,
  priceLayout,
  quantityLimitLayout,
  imagesLayout,
  descsLayout,
  pubsLayout,
  barcodesLayout,
]

/*Omnichannel internal navigation*/
export const discountTablePageSection = 'discount'
export const brandDiscountTablePageSection = 'brandDiscount'

/*Theme*/
export const LightTheme = 'light'
export const DarkTheme = 'dark'

/*Image Types*/
export enum ImageType {
  Main = 'P',
  Detail = 'D',
  Draw = 'S',
  Marketplace = 'M',
}

export enum PIMImageType {
  Main = 'Main',
  Detail = 'Detail',
  Draw = 'Draw',
  Marketplace = 'Marketplace',
}

export const AllImageOption = 'All'

export const ImageTypeTranslations = [
  { key: ImageType.Main, translation: TranslationKeys.imageTypeMain },
  { key: ImageType.Detail, translation: TranslationKeys.imageTypeDetail },
  { key: ImageType.Draw, translation: TranslationKeys.imageTypeDraw },
  { key: ImageType.Marketplace, translation: TranslationKeys.imageTypeMarketplace },
  { key: AllImageOption, translation: TranslationKeys.imageTypeAll },
]

export const PimImageTypeTranslations = [
  { key: PIMImageType.Main, translation: TranslationKeys.pimImageTypeMain },
  { key: PIMImageType.Detail, translation: TranslationKeys.pimImageTypeDetail },
  { key: PIMImageType.Draw, translation: TranslationKeys.pimImageTypeDraw },
  { key: PIMImageType.Marketplace, translation: TranslationKeys.pimImageTypeMarketplace },
]

// /*Profile Constant*/
// export const ShopProfile = 1
// export const MpWebProfile = 2
// export const WebAgencyProfile = 3
// export const BkProfile = 4
// export const SuperProfile = 5
// export const PimProfile = 6

export const ProfilesKeys = {
  ShopProfile: 1,
  MpWebProfile: 2,
  WebAgencyProfile: 3,
  BkProfile: 4,
  SuperProfile: 5,
  PimProfile: 6,
}
export type ProfilesKeysType = keyof typeof ProfilesKeys

export const getProfileKey = (profile: any): ProfilesKeysType => {
  const idProfile = parseInt(`${profile}`)
  const profileKeys = Object.entries(ProfilesKeys)
    .filter(e => e[1] == idProfile)
    .map(e => e[0]) as ProfilesKeysType[]
  return profileKeys.length > 0 ? profileKeys[0] : 'SuperProfile'
}

/*Empty Filter*/
export const EmptyFilterChecked = '$None$'
export const NegateFilterSearched = '---'

/*Edit selection constant*/
export const AllRowSelected = 'AllSelected'

/*Filter Constant*/
export const mktFilterYes = 'yes'
export const mktFilterNo = 'no'
export const mktFilterAll = 'all'

/*Configuration*/
export const configurationEmptyTableOptions = '_emptyTableOptions'
export const configurationExtraDescription = '_extraDescriptionLangOptions'
export const configurationEmptyExtraDescription = '_emptyExtraDescriptions'
export const configurationNegateTableColumns = '_negateTableColumns'
export const configurationFilterSearch = '_filterSearch'
export const configurationActiveStore = '_activeStore'
export const configurationQuantitiesFilter = '_quantitiesFilter'
export const configurationAvailabilitiesFilter = '_availabilitiesFilter'
export const configurationMarketplaceCategorySort = '_marketplaceCategorySort'
export const configurationLanguage = '_language'
export const configurationHiddenElements = '_hiddenElements'
export const configurationActiveFilters = '_activeFilters'
export const configurationPricelists = '_pricelists'
export const configurationHiddenQuantitiesFilter = '_hiddenQuantitiesFilter'
export const configurationGridLayout = '_gridLayout'
export const configurationTheme = 'theme'

const LoadConfiguration = 'loadConfiguration'
const LoadProfileOptions = 'loadProfileOptions'
const SaveConfiguration = 'saveConfiguration'
const DeleteConfiguration = 'deleteConfiguration'
const RenameConfiguration = 'renameConfiguration'
const SaveDefaultConfigurations = 'saveDefaultConfigurations'

/* Integration Constant */
export const PostObjOption = 'Opzioni'

export enum ConfigurationForm {
  POS = 'POS',
  GRUCCIA = 'GRUCCIA',
}

export const PostObjReload = 'Ricarica'
export const PostObjGrid = 'Griglie'
export const PostObjMarketplace = 'OpzioniMarket'
export const PostObjBarcode = 'OpzioniBarcode'
export const PostObjParameters = 'Parametri'

export enum Stores {
  Local = 'NegozioHome',
  Nearby = 'NegoziVicini',
  Remote = 'NegoziLontani',
  Excluded = 'NegoziEscludere',
  All = 'TUTTI',
}

export enum PricelistTypeFilter {
  ALL = 'ALL',
  B2B = 'B2B',
  B2C = 'B2C',
}

/*Profile Options UICODE / ID*/

export const UiCodeEnableEdit = 'EnableEdit'
export const UiCodeEnableTabSituazione = 'EnableTabSituazione'
export const UiCodeEnableMovements = 'EnableMovements'
export const UiCodeEnableTabMovements = 'EnableTabMovements'
export const UiCodeEnableAvailabilityView = 'EnableAvailabilityView'
export const UiCodeEnableMovementLog = 'EnableMovementLog'
export const UiCodeShowMovementPrice = 'ShowMovementPrice'
export const UiCodeEnableTabAvailabilities = 'EnableTabAvailabilities'
export const UiCodeVersionNumber = 'VersionNumber'
export const UiCodePricesOmnichannel = 'PricesSection'
export const UiCodeLimitQty = 'LimitQtySection'
export const UiCodePIM = 'PIM'
export const UiCodeSettings = 'Settings'
export const UiCodeUtility = 'Utility'

/*Hidden Area*/
export const HideQuantities = 'hideQuantities'
export const HideFilterElement = 'hideFilterElement'
export const HideBarcodeElement = 'hideBarcodeElement'
export const HideDimensionLocal = 'hideDimensionLocalElement'
export const HideDimensionNearby = 'hideDimensionNearbyElement'
export const HideDimensionRemote = 'hideDimensionRemoteElement'
export const HideInterrogationType = 'hideInterrogationTypeElement'
export const HideWorkspaceDropdown = 'hideWorkspaceDropdown'
export const HidePredefinedFilters = 'hidePredefinedFilters'
export const HideExtraFilters = 'hideExtraFilters'
export const HidenPriceFilters = 'hidePriceFilters'
export const HideOptionalFilters = 'hideOptionalFilters'
export const HideWebAndMarketingFilters = 'hideWebAndMarketingFilters'
export const HideMovement = 'hideMovement'
export const HideAvailability = 'hideAvailability'
export const HideMarketplace = 'hideMarketplaceAvailabilities'
export const HideEdit = 'hideDiwaEdit'
export const HideFiltersNotActiveForQuantities = 'hideFiltersNotActiveForQuantities'
export const HideUnlockMovementButton = 'hideUnlockMovementButton'
export const HidePrices = 'hidePrices'
export const HidePIMIMages = 'hidePimImages'
export const HideQuantityLimits = 'hideQuantityLimits'
export const HideDiwaReactGridLayoutColumnsBtn = 'hideDiwaReactGridLayoutColumnsBtn'

/*Redux Action*/

export const IsLoadConfigurationAction = action => {
  return action.type.endsWith(LoadConfiguration)
}

export const IsLoadProfileOptionsAction = action => {
  return action.type.endsWith(LoadProfileOptions)
}

export const IsSaveConfigurationAction = action => {
  return action.type.endsWith(SaveConfiguration)
}

export const IsDeleteConfigurationAction = action => {
  return action.type.endsWith(DeleteConfiguration)
}

export const IsRenameConfigurationAction = action => {
  return action.type.endsWith(RenameConfiguration)
}

export const IsSaveDefaultConfigurationsAction = action => {
  return action.type.endsWith(SaveDefaultConfigurations)
}

const SaveRowKeys = 'saveRowKeys'
export const IsSaveRowKeysAction = action => {
  return action.type.endsWith(SaveRowKeys)
}

const ClearArticleInfoAndSetArticleKey = 'clearArticleInfoAndSetArticleKey'
export const IsClearArticleInfoAction = action => {
  return action.type.endsWith(ClearArticleInfoAndSetArticleKey)
}

const SetFullEditSelection = 'setFullEditSelection'
export const IsSetFullEditSelectionAction = action => {
  return action.type.endsWith(SetFullEditSelection)
}

const ToggleEditTable = 'toggleEditTable'
export const IsToggleEditTableAction = action => {
  return action.type.endsWith(ToggleEditTable)
}

const SetConfigurationForMessageEvent = 'setConfigModeForMessageEvent'
export const IsSetConfigurationForMessageEvent = action => {
  return action.type.endsWith(SetConfigurationForMessageEvent)
}

const SaveArticles = 'saveArticles'
export const IsSaveArticles = action => {
  return action.type.endsWith(SaveArticles)
}

const RestoreSelectionAndUpdateQuantities = 'restoreSelectionAndUpdateQuantities'
export const IsRestoreSelectionAndUpdateQuantities = action => {
  return action.type.endsWith(RestoreSelectionAndUpdateQuantities)
}

const SaveBarcode = 'saveBarcode'
export const IsSaveBarcode = action => {
  return action.type.endsWith(SaveBarcode)
}

const SaveFilters = 'saveFilters'
export const IsSaveFilters = action => {
  return action.type.endsWith(SaveFilters)
}

const SetActiveStore = 'setActiveStore'
export const IsSetActiveStore = action => {
  return action.type.endsWith(SetActiveStore)
}

const SetFilterSearchValue = 'setFilterSearchValue'
export const IsSetFilterSearchValue = action => {
  return action.type.endsWith(SetFilterSearchValue)
}

const ClearTagFiltersValue = 'clearTagFilters'
export const IsClearTagFiltersValue = action => {
  return action.type.endsWith(ClearTagFiltersValue)
}

const MovementTabVisible = 'setMovementTabVisible'
export const IsSetMovementTabVisible = action => {
  return action.type.endsWith(MovementTabVisible)
}

const AvailabilityTabVisible = 'setAvailabilityTabVisible'
export const IsSetAvailabilityTabVisible = action => {
  return action.type.endsWith(AvailabilityTabVisible)
}

/*Tag Filters*/
export const negatePopover = 'negatePopover'
export const emptyPopover = 'emptyPopover'
export const searchedPopover = 'searchedPopover'

/* Languages */
export const Language_IT = 'IT'
export const Language_EN = 'EN'
export const Language_FR = 'FR'
export const Language_ES = 'ES'

export const LanguageList = [Language_IT, Language_EN, Language_ES, Language_FR]

/*Incipit Translations Class*/
export const FilterLangClass = 'filter'
export const CheckboxLangClass = 'checkbox'
export const TableColumnTranslationPrefix = 'table'
export const AvailTableColumnTranslationPrefix = 'tableAvailabilities'
export const MktTableColumnTranslationPrefix = 'tableMarketplace'
export const QuantitiesLabelLangClass = 'quantitiesLabel'
export const QuantitiesHeadLangClass = 'quantitiesHead'

/* Upper menu filter dropdown values */
export const MovementsOption = 'movements'
export const AvailabilitiesOption = 'availabilities'
export const ExistanceOption = 'existance'
export const AllOption = 'all'

/*Pricelist filter constant*/
export const VariantModelValue = 'M/V'
export const BaseStorePricelist = '$STOREMV$'
export const PriceListProfileOptionValueAll = 'TUTTI'

/*Article filter section*/
export const PredefinedFilters = 'predefinedFilters'
export const ExtraFilters = 'extraFilters'
export const PriceFilters = 'priceFilters'
export const OptionalsFilters = 'optionalsFilters'
export const PriceListsFilters = 'pricelists'
export const WebAndMarketingFilters = 'webAndMarketingFilters'

/*Model search constant*/
export const ModelKey = 'modelKey'

/*Quantities Table*/
export const StoreName = 'storeName'
export const StoreId = 'storeId'
export const Total = 'total'
export const ExistingStock = 'existingStock'
export const AvailableStock = 'availability'
export const PlaceHolderCol = 'placeholder'

export const ExtraRecapRow = 'recap'

export const StockInitial = 'stockInitial'
export const HockB2B = 'hockB2B'
export const Ordered = 'ordered'
export const Delivered = 'delivered'
export const Unfilled = 'unfilled'
export const ReturnSupplier = 'returnSupplier'
export const HockB2C = 'hockB2C'
export const Purchased = 'purchased'
export const Sellout = 'sellout'
export const ReturnCustomer = 'returnCustomer'
export const WithDrawn = 'withdrawn'
export const InVision = 'onConsignement'
export const Tailoring = 'tailorShop'
export const Transit = 'transit'
export const Entries = 'entries'
export const Exits = 'exits'

export const Inbound = 'inbound'
export const Outbound = 'outbound'
export const Neutral = 'neutral'

/*Movements Availabilities Select */
export const MovementsSelectValue = 'movements'
export const AvailabilitiesSelectValue = 'availabilities'

/*Movements Availabilities Table */
export const Causal = 'causal'
export const Quantity = 'quantity'
export const DateHeader = 'date'
export const HAStoreName = 'storeName'
export const ExtraLogs = 'extraLogs'
export const Sizes = 'sizes'
export const DocumentationNumber = 'documentationNumber'
export const Status = 'status'
export const Reference = 'reference'
export const UserDetail = 'userDetail'
export const EditDate = 'dateStamp'
export const OperationId = 'dbId'
export const EnableMovementLog = 'enableMovementLog'
export const ProgressiveAvailability = 'progressiveAvailability'
export const CheckValueForAvailability = 'availability'

//Column length for both table
export const CausalColLength = 140
export const QuantityColLength = 80
export const DateHeaderColLength = 120
export const DocumentationNumberColLength = 120
export const ProgressiveAvailabilityColLength = 115
export const DetailExpandColLength = 90
export const IndividualSizeColLength = 40

export const HAStoreNameLogColLength = 172
export const HAStoreNameExtraLogColLength = 164
export const HAStoreNameAvailabilitiesLogColLength = 166

export const EditDateColLength = 120
export const UserDetailColLength = 150
export const SizesColLength = 160
export const OperationIdColLength = 120
export const MovementAvailabilitiesDefaultColLength = 180

export const HandlingExpandColLength = 25
/*----------------------------*/

export const SizeFilterDefaultValue = 'size'
export const MarketplaceDefaultValue = 'marketplace'

/*Causal constant */
export const AllCausal = 'All'
export const AvailableOnlyCausal = 'AvailableOnly'

/*Marketplace Availabilities table*/
export const MarketplaceCategory = 'category'
export const MarketplaceStoreName = 'storeName'
export const DefaultOrderCategoryMarketplace = 'Marketplace'
export const DefaultOrderCategoryWebsite = 'Siti'
export const DefaultOrderCategoryLogistic = 'Logistica/B2B'
export const ImpegnatoSpecialStoreName = 'Impegnato'
export const ImpegnatoRowName = 'engaged'
export const MarketplaceStoreTotal = 'total'

/*Image*/
export const photoboxDroppableId = 'photo-box'
export const GalleryDefaultValue = 'gallery'
/*OMNICHANNEL*/

export const outletSeasonId = -2
export const defaultSectorId = 0
export const defaultSupergroupId = 0

export const listingsAllValue = 'all'

export enum RuleType {
  season = 0, //normale
  salesPeriod = 1, //saldo
  promo = 2, //promo
}

export enum ArticlePubbType {
  notactive = 0,
  active = 1,
  pronto = 2,
  noex = -1,
}

export const subruleDropdownAll = 'all'
export const subruleDropdownModified = 'modified'

export const UseridBKdefault = '-04'
export const UseridBKdefaultGDPR = '2'

export const maxRuleLength = 255

const SetCurrentRuleSelected = 'setCurrentRuleSelected'
export const IsSetCurrentRuleSelected = action => {
  return action.type.endsWith(SetCurrentRuleSelected)
}

const SetSubruleId = 'setSubRuleId'
export const IsSetSubruleId = action => {
  return action.type.endsWith(SetSubruleId)
}

const AddRule = 'addRule'
export const IsAddRule = action => {
  return action.type.endsWith(AddRule)
}

const AddSubRule = 'addSubRule'
export const IsAddSubRule = action => {
  return action.type.endsWith(AddSubRule)
}

/*query param*/

export const supergroupParam = 'supergroup'
export const supergroupSuperParam = 'supergroupsuper'
export const sectorParam = 'sector'
export const brandParam = 'brand'
export const visibilityParam = 'visibility'
